import { useEffect, useRef } from "react";

import { getWoActivitySocket, rejoinWoActivityCompany } from "src/Services/socket/woActivitySocket";

/**
 * Calls onActivity({ woId, kind }) when a customer creates a request
 * (kind "request") or signs / declines a proposal (kind "proposal"), so a page
 * can refresh without a reload. The latest onActivity is always used.
 */
function useWoCustomerActivity(onActivity) {
  const handlerRef = useRef(onActivity);
  handlerRef.current = onActivity;

  useEffect(() => {
    const socket = getWoActivitySocket();
    rejoinWoActivityCompany();
    const onEvent = (payload) => handlerRef.current?.(payload);
    socket.on("wo-customer-activity", onEvent);
    return () => {
      socket.off("wo-customer-activity", onEvent);
    };
  }, []);
}

export default useWoCustomerActivity;
